module.exports = __webpack_public_path__ + "img/cardmachine.07f2bcb3.svg";